module.exports = __webpack_public_path__ + "img/shangjia.2ef8ac4f.png";